import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import { Toaster } from 'react-hot-toast';
import { isAbortError, reportError } from '@/utils/errors';
import ErrorBoundary from './components/ErrorBoundary';
import { APP_BASENAME, normalizeAppBasePath } from './config/routes';
import journalIcon40 from './assets/icons/journal-40.svg';
import journalIcon60 from './assets/icons/journal-60.svg';

const additionalIcons = [
  { href: journalIcon40, sizes: '40x40' },
  { href: journalIcon60, sizes: '60x60' },
];

additionalIcons.forEach(({ href, sizes }) => {
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.sizes = sizes;
  link.href = href;
  document.head.append(link);
});

normalizeAppBasePath();

window.onerror = function (message, _source, _line, _column, error) {
  reportError(error ?? message);
};
window.onunhandledrejection = function (event) {
  if (isAbortError(event.reason)) {
    event.preventDefault();
    return;
  }
  reportError(event.reason);
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <>
    <Toaster
      position="top-center"
      toastOptions={{
        error: {
          style: {
            background: '#ffe4e6',
            border: '1px solid #fda4af',
            color: '#881337',
          },
        },
      }}
    />
    <ErrorBoundary>
      <BrowserRouter basename={APP_BASENAME}>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </>,
);
